"use strict";

exports.buildImagePath = function (imageName) {
  return '/web-templates/assets/images/' + imageName;
};